import axios from 'axios';
import { GET_FORMULAS, ADD_FORMULA, DELETE_FORMULA, FORMULAS_LOADING, CLEAR_FORMULAS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IFormula } from '../../types/interfaces';
import store from '../store';

export const getFormulas = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: FORMULAS_LOADING
  });
  axios
    .get('/api/formulas', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_FORMULAS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const verifyFormulaAvailability = async (vente_u_percent: number | null, vente_u_each: number | null, vente_a_percent: number | null, vente_a_each: number | null, part_percent: number | null, part_each: number | null, livraison_percent: number | null, livraison_each: number | null, signature_client_percent: number | null, signature_client_each: number | null, chez_notaire_percent: number | null, chez_notaire_each: number | null, enc_non_recep_percent: number | null, enc_non_recep_each: number | null, enc_recep_percent: number | null, enc_recep_each: number | null, enc_verse_percent: number | null, enc_verse_each: number | null, enc_encaisse_percent: number | null, enc_encaisse_each: number | null, enc_impaye_percent: number | null, enc_impaye_each: number | null, enc_inactif_percent: number | null, enc_inactif_each: number | null, enc_impaye_inactif_percent: number | null, enc_impaye_inactif_each: number | null) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/formulas/verifyAvailability', {...tokenConfig(store.getState), params: {vente_u_percent, vente_u_each, vente_a_percent, vente_a_each, part_percent, part_each, livraison_percent, livraison_each, signature_client_percent, signature_client_each, chez_notaire_percent, chez_notaire_each, enc_non_recep_percent, enc_non_recep_each, enc_recep_percent, enc_recep_each, enc_verse_percent, enc_verse_each, enc_encaisse_percent, enc_encaisse_each, enc_impaye_percent, enc_impaye_each, enc_inactif_percent, enc_inactif_each, enc_impaye_inactif_percent, enc_impaye_inactif_each}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const addFormula = (formula: IFormula, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/formulas', {formula}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_FORMULA,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteFormula = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/formulas/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_FORMULA,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setFormulasLoading = () => {
  return {
    type: FORMULAS_LOADING
  };
};

export const clearFormulas = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_FORMULAS
  })
};